import { Field } from '#app/components/form/field.tsx'
import { SelectField } from '#app/components/form/select-field.tsx'
import { REPOSITORY_SYSTEM_OPTIONS } from '#app/routes/mocra+/_form+/components/repositories/constants.ts'
import {
	type RepositoryDraft,
	type RepositorySystemValue,
} from '#app/routes/mocra+/_form+/components/repositories/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly repository: RepositoryDraft
	readonly systemErrors: readonly string[]
	readonly locationErrors: readonly string[]
	readonly onSystemChange: (value: RepositorySystemValue) => void
	readonly onLocationChange: (value: string) => void
}

export function SafetyRepositorySection({
	resources,
	repository,
	systemErrors,
	locationErrors,
	onSystemChange,
	onLocationChange,
}: Props) {
	return (
		<Section
			title="Safety dossier repository"
			description="Note where ingredient safety evidence lives so inspectors can access it on demand."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
			childrenClassName="space-y-4"
		>
			<SelectField
				labelProps={{
					children: 'Which system stores the safety dossier?',
				}}
				selectProps={{
					name: 'safetyRepository.system',
					value: repository.system,
					onChange: (event) =>
						onSystemChange(event.target.value as RepositorySystemValue),
				}}
				options={REPOSITORY_SYSTEM_OPTIONS}
				errors={systemErrors.length > 0 ? [...systemErrors] : undefined}
			/>
			<Field
				labelProps={{
					children: 'Where can someone find the folder or record?',
				}}
				inputProps={{
					name: 'safetyRepository.location',
					type: 'text',
					value: repository.location,
					onChange: (event) => onLocationChange(event.target.value),
				}}
				errors={locationErrors.length > 0 ? [...locationErrors] : undefined}
			/>
		</Section>
	)
}
